/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_No_Auth_AccountInputs */

const fr_account_audit_no_auth_account = /** @type {(inputs: Account_Audit_No_Auth_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun compte d'authentification associé`)
};

/**

* @param {Account_Audit_No_Auth_AccountInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_no_auth_account = /** @type {((inputs?: Account_Audit_No_Auth_AccountInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_No_Auth_AccountInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_no_auth_account(inputs)
});